module.exports = __webpack_public_path__ + "img/moonlit.765e7170.png";